(function(){
  var desktopCounter=0;

  function injectDesktopPortalStyles(){
    if(document.getElementById('mq-desktop-portal-style'))return;
    var style=document.createElement('style');
    style.id='mq-desktop-portal-style';
    style.textContent='@media(max-width:760px){.mq-desktop-portal{display:none!important}}@media(min-width:761px){.mq-desktop-portal{display:none;position:fixed;z-index:2147482000;width:min(310px,calc(100vw - 40px));padding:10px;gap:0;flex-direction:column;align-items:stretch;background:#f7f1ea;border:1px solid rgba(73,55,47,.15);border-radius:18px;box-shadow:0 20px 50px rgba(73,55,47,.16);transform:translateX(-50%)}.mq-desktop-portal.is-open{display:flex}.mq-desktop-portal a{display:block;width:100%;padding:11px 12px;border-radius:10px;font-family:\'Young Serif\',serif;font-size:13px;line-height:1.3;color:#49372f;text-decoration:none;text-align:left;white-space:normal}.mq-desktop-portal a:hover{background:rgba(255,255,255,.72)}.mq-desktop-portal a:last-child{color:#8b5e3c}}';
    document.head.appendChild(style);
  }

  function setLocked(open){
    document.documentElement.classList.toggle('mq-menu-open',open);
    document.body.classList.toggle('mq-menu-open',open);
  }

  function setMenu(toggle,menu,open){
    if(!toggle||!menu)return;
    menu.classList.toggle('is-open',open);
    toggle.setAttribute('aria-expanded',open?'true':'false');
    toggle.setAttribute('aria-label',open?'Menü bezárása':'Menü megnyitása');
    menu.setAttribute('aria-hidden',open?'false':'true');
    setLocked(open);
    if(open){
      var close=menu.querySelector('.mq-mobile-close');
      if(close)setTimeout(function(){close.focus();},50);
    }else if(document.activeElement&&menu.contains(document.activeElement)){
      toggle.focus();
    }
  }

  function findAndMountMenu(toggle){
    var id=toggle.getAttribute('aria-controls');
    if(!id)return null;
    var section=toggle.closest('.shopify-section');
    var menu=section?section.querySelector('[id="'+id+'"]'):null;
    if(!menu)menu=document.getElementById(id);
    if(!menu)return null;
    document.querySelectorAll('.mq-mobile-menu[id="'+id+'"]').forEach(function(other){
      if(other!==menu&&other.parentNode===document.body)other.remove();
    });
    if(menu.parentNode!==document.body)document.body.appendChild(menu);
    return menu;
  }

  function initMobile(root){
    (root||document).querySelectorAll('.mq-mobile-toggle').forEach(function(toggle){
      if(toggle.dataset.mqMenuReady==='true')return;
      var menu=findAndMountMenu(toggle);
      if(!menu)return;
      toggle.dataset.mqMenuReady='true';
      var close=menu.querySelector('.mq-mobile-close');
      toggle.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        setMenu(toggle,menu,!menu.classList.contains('is-open'));
      });
      if(close)close.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();setMenu(toggle,menu,false);});
      menu.querySelectorAll('a').forEach(function(link){link.addEventListener('click',function(){setMenu(toggle,menu,false);});});
    });
  }

  function closeMobile(){
    document.querySelectorAll('.mq-mobile-menu.is-open').forEach(function(menu){
      var toggle=document.querySelector('.mq-mobile-toggle[aria-controls="'+menu.id+'"]');
      setMenu(toggle,menu,false);
    });
    setLocked(false);
  }

  function removeMobileOrphans(){
    document.querySelectorAll('body > .mq-mobile-menu').forEach(function(menu){
      var toggle=document.querySelector('.mq-mobile-toggle[aria-controls="'+menu.id+'"]');
      if(!toggle)menu.remove();
    });
  }

  function positionDesktopPortal(button,portal){
    if(!button||!portal)return;
    var rect=button.getBoundingClientRect();
    portal.style.left=(rect.left+(rect.width/2))+'px';
    portal.style.top=(rect.bottom+10)+'px';
  }

  function closeDesktop(except){
    document.querySelectorAll('.mq-desktop-portal.is-open').forEach(function(portal){
      if(except&&portal===except)return;
      portal.classList.remove('is-open');
      portal.setAttribute('aria-hidden','true');
      var button=document.querySelector('.mq-desktop-toggle[aria-controls="'+portal.id+'"]');
      if(button)button.setAttribute('aria-expanded','false');
    });
  }

  function removeDesktopOrphans(){
    document.querySelectorAll('body > .mq-desktop-portal').forEach(function(portal){
      var button=document.querySelector('.mq-desktop-toggle[aria-controls="'+portal.id+'"]');
      if(!button)portal.remove();
    });
  }

  function initDesktop(root){
    injectDesktopPortalStyles();
    (root||document).querySelectorAll('.mq-header').forEach(function(header){
      if(header.dataset.mqDesktopReady==='true')return;
      var nav=header.querySelector('.mq-nav');
      if(!nav)return;
      header.dataset.mqDesktopReady='true';

      Array.prototype.slice.call(header.children).forEach(function(child){
        if(child.classList&&child.classList.contains('mq-desktop-toggle'))child.remove();
      });

      desktopCounter+=1;
      var portal=document.createElement('nav');
      portal.id='MancsiQDesktopMenu-'+desktopCounter;
      portal.className='mq-desktop-portal';
      portal.setAttribute('aria-label','MancsiQ főmenü');
      portal.setAttribute('aria-hidden','true');
      portal.innerHTML=nav.innerHTML;
      document.body.appendChild(portal);

      var button=document.createElement('button');
      button.type='button';
      button.className='mq-desktop-toggle';
      button.setAttribute('aria-expanded','false');
      button.setAttribute('aria-haspopup','true');
      button.setAttribute('aria-controls',portal.id);
      button.innerHTML='<span>Főmenü</span><span class="mq-desktop-caret" aria-hidden="true">⌄</span>';
      header.insertBefore(button,nav);

      button.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        var open=!portal.classList.contains('is-open');
        closeDesktop(portal);
        if(open){
          positionDesktopPortal(button,portal);
          portal.classList.add('is-open');
          portal.setAttribute('aria-hidden','false');
          button.setAttribute('aria-expanded','true');
        }else{
          portal.classList.remove('is-open');
          portal.setAttribute('aria-hidden','true');
          button.setAttribute('aria-expanded','false');
        }
      });

      portal.querySelectorAll('a').forEach(function(link){
        link.addEventListener('click',function(){closeDesktop();});
      });
    });
  }

  function init(root){initMobile(root);initDesktop(root);}

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});
  else init(document);

  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:section:unload',function(){closeMobile();closeDesktop();setTimeout(function(){removeMobileOrphans();removeDesktopOrphans();},0);});
  document.addEventListener('click',function(e){
    if(!e.target.closest('.mq-desktop-toggle')&&!e.target.closest('.mq-desktop-portal'))closeDesktop();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeMobile();closeDesktop();}});
  window.addEventListener('resize',function(){
    if(window.innerWidth>760){
      closeMobile();
      document.querySelectorAll('.mq-desktop-portal.is-open').forEach(function(portal){
        var button=document.querySelector('.mq-desktop-toggle[aria-controls="'+portal.id+'"]');
        if(button)positionDesktopPortal(button,portal);
      });
    }else closeDesktop();
  });
  window.addEventListener('scroll',function(){
    if(window.innerWidth<=760)return;
    document.querySelectorAll('.mq-desktop-portal.is-open').forEach(function(portal){
      var button=document.querySelector('.mq-desktop-toggle[aria-controls="'+portal.id+'"]');
      if(button)positionDesktopPortal(button,portal);
    });
  },{passive:true});
})();
